import type { ImageProps } from "next/image"
import { createContext, useContext } from "react"

export const ImageMapContext = createContext<Record<number, ImageProps | null>>({})
export const useImageMap = () => useContext(ImageMapContext)
